// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1b78f5{display:flex;flex-wrap:wrap;gap:1em .5em;justify-content:flex-end}", ""]);
// Exports
exports.locals = {
	"tags": "_1b78f5"
};
module.exports = exports;
